<template>
  <div class="animated fadeIn demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <Row>
          <Select
            size="small"
              style="width: 200px; margin-right: 3px;"
              v-model="selectGroupId"
              filterable
              clearable
              remote
              :remote-method="searchGroup"
              :loading="searchGroupLoading">
            <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
          </Select>
          <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
          <Button type="primary" size="small" style="margin-right: 3px;" @click="onClear">清空</Button>
        </Row>
<!--        <Row style="margin-top: 10px;">-->
<!--          <Col span="24">-->
<!--            <li @click="onUnGroupClick">未分组车辆</li>-->
<!--          </Col>-->
<!--        </Row>-->
        <Row :style="{height:(treeHeight + 'px'), overflow:'auto'}">
          <Col span="24">
            <Tree :data="defaultGroupData" :load-data="onLoadChildrenGroupData" style="overflow: hidden;" :render="renderContent"></Tree>
          </Col>
        </Row>
      </div>
      <div slot="right" class="demo-split-pane">
        <Row>当前选择分组:<label style="color: cornflowerblue">{{selectVehicleInfosByGroupName}}</label></Row>
        <Row>
          <div style="width: 100%;">
            <div style="position:relative;">
              <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
              <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                     @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
              <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
              </div>
            </div>
            <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
                  show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
                  style="text-align:right;margin-top:3px;"></Page>
          </div>
        </Row>
      </div>
    </Split>
    <add-vehicle-info-group-modal v-model="addVehicleInfoGroupModal" :parentGroupId="addVehicleInfoGroupParentId" @on-success="onGroupOPSuccess"></add-vehicle-info-group-modal>
    <vehicle-info-group-detail-modal v-model="vehicleInfoGroupDetailModal" :isMyGroup="true" :initValue="vehicleInfoGroupDetailId" @on-success="onGroupOPSuccess"></vehicle-info-group-detail-modal>

    <add-vehicle-info-modal v-model="addVehicleInfoModal" @on-success="onSuccess"></add-vehicle-info-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <vehicle-picture-modal v-model="vehiclePictureModal" :initValue="vehiclePictureId"></vehicle-picture-modal>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo" :showBusinessState="false"
                                @on-success="onModifySuccess"></business-note-detail-modal>
    <change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserVehicleInfoId" @on-success="onModifySuccess"></change-business-user-modal>
    <assemble-positioning-device-modal v-model="assemblePositioningDeviceModal" :initValue="assembleVehicleInfoId" @on-success="onModifySuccess"></assemble-positioning-device-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>
<script>
import AddVehicleInfoGroupModal from '@/view/crm/components/add-vehicle-info-group-modal'
import VehicleInfoGroupDetailModal from '@/view/crm/components/vehicle-info-group-detail-modal'

import AddVehicleInfoModal from '@/view/crm/components/add-vehicle-info-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import VehiclePictureModal from '@/view/crm/components/vehicle-picture-modal'
import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'
import ChangeBusinessUserModal from '@/view/crm/components/change-business-user-modal'
import AssemblePositioningDeviceModal from '@/view/im/components/assemble-positioning-device-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else if (colorid === 5) {
    return '#ffffff'
  } else {
    return '#000000'
  }
}

function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else if (colorid === 5) {
    return '#009900'
  } else {
    return '#bbbec4'
  }
}

export default {
  // 此名称与routers.js中name一致方可缓存
  name: 'myvehicleinfogroups',
  components: {
    AddVehicleInfoGroupModal,
    VehicleInfoGroupDetailModal,

    VehiclePictureModal,
    AddVehicleInfoModal,
    VehicleInfoDetailModal,
    BusinessNoteDetailModal,
    ChangeBusinessUserModal,
    AssemblePositioningDeviceModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      treeHeight: 400,

      sexFilter: null,
      stateFilter: null,

      // 配置设备
      assemblePositioningDeviceModal: false,
      assembleVehicleInfoId: null,

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserVehicleInfoId: null,

      // 图片管理
      vehiclePictureModal: false,
      vehiclePictureId: null,

      // 添加收入项
      addVehicleInfoModal: false,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        vehicleInfoId: null
      },

      // 添加车辆分组
      addVehicleInfoGroupModal: false,
      addVehicleInfoGroupParentId: null,

      // 车辆组详细信息
      vehicleInfoGroupDetailModal: false,
      vehicleInfoGroupDetailId: null,

      filterType: [],
      split1: 0.3,
      keywordFilter: null,
      isSearch: false,
      tempChildrenGroups: null,
      searchGroupLoading: false,
      searchGroupList: [],
      selectGroupId: null,
      selectVehicleInfosByGroupId: null,
      selectVehicleInfosByGroupName: null,
      defaultGroupData: [],

      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      pageSize: 0,
      content: [],
      totalElements: 0,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '车牌',
          resizable: true,
          key: 'name',
          ellipsis: 'true',
          width: 120,
          render: function (h, params) {
            let registrationNum = params.row.registrationNum
            if (params.row.customName) {
              registrationNum = registrationNum + '(' + params.row.customName + ')'
            }
            return h('div', {
              props: {
                disabled: false
              },
              style: {
                'text-align': 'center',
                backgroundColor: calRegistrationColor(params.row.registrationColor),
                color: calRegistrationTextColor(params.row.registrationColor)
              },
              on: {
                click: () => {
                  // this.onRegistrationNOClick(params.row)
                }
              }
            }, registrationNum)
          }
        },
        {
          title: '车架号',
          resizable: true,
          key: 'vin',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '车辆类型',
          resizable: true,
          key: 'vehicleTypeId',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.vehicleType) {
              return h('label', params.row.vehicleType.name)
            }
          }
        },
        {
          title: '发动机号',
          resizable: true,
          key: 'engineNum',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '定位设备',
          resizable: true,
          ellipsis: 'true',
          width: 250,
          render: function (h, params) {
            let positioningDeviceInfos = params.row.positioningDeviceInfos
            if (positioningDeviceInfos && positioningDeviceInfos.length > 0) {
              let display = ''
              positioningDeviceInfos.forEach(item => {
                let displaySims = null
                display = display + '(到费期:' + new Date(item.serviceDatetime).Format('yyyy年MM月dd日') + ')'
                if (item.simInfos && item.simInfos.length > 0) {
                  displaySims = ''
                  item.simInfos.forEach(item => {
                    displaySims = displaySims + item.simNum + '|'
                  })
                  displaySims = displaySims.substr(0, displaySims.length - 1)
                  display = display + item.terminalNum + '[SIM卡号:' + displaySims + ']' + '|'
                } else {
                  display = display + item.terminalNum + '|'
                }
              })
              display = display.substr(0, display.length - 1)
              return h('div', display)
            } else {
              return h('div', '未安装')
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 400,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.id
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehiclePictureId = params.row.id
                    this.vehiclePictureModal = true
                  }
                }
              }, '图片管理'),
              h('Button', {
                props: {
                  type: params.row.businessNoteId == null ? 'primary' : 'success',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.businessNoteInfo.vehicleInfoId = params.row.id
                    this.businessNoteInfo.id = params.row.businessNoteId
                    this.businessNoteDetailModal = true
                  }
                }
              }, '业务笔记'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.assembleVehicleInfoId = params.row.id
                    this.assemblePositioningDeviceModal = true
                  }
                }
              }, '配置设备'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.changeBusinessUserVehicleInfoId = params.row.id
                    this.changeBusinessUserModal = true
                  }
                }
              }, '指定业务跟进')
            ])
          }
        }
      ]// cloumn
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoGroupServ_GetRootVehicleInfoGroups',
      'VehicleInfoGroupServ_GetChildrenVehicleInfoGroups',
      'VehicleInfoGroupServ_SearchByName',
      'VehicleInfoGroupServ_GetDetail',
      'UserServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onUnGroupClick () {
      this.selectVehicleInfosByGroupName = '未分组车辆'
      this.selectVehicleInfosByGroupId = null
      this.setPage(1)
    },
    onClear () {
      this.selectGroupId = null
      this.defaultGroupData = null
    },
    onAddRootVehicleInfoGroupClick () {
      this.addVehicleInfoGroupParentId = null
      this.addVehicleInfoGroupModal = true
    },
    onFilterTypeChange () {
      this.refreshPage(this.pageFilter)
    },
    searchGroup (input) {
      this.searchGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchGroupList = []
        this.searchGroupLoading = false
      } else {
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
      }
    },
    onFilterClick () {
      console.log(this.selectGroupId)
      if (this.selectGroupId) {
        console.log('加载')
        store.dispatch('VehicleInfoGroupServ_GetDetail', {
          params: { id: this.selectGroupId },
          urlparams: null
        }).then(() => {
          let result = store.getters.get_VehicleInfoGroup_GetDetailResult ? store.getters.get_VehicleInfoGroup_GetDetailResult : []
          this.defaultGroupData = [{
            id: result.id,
            title: result.name,
            expand: false,
            loading: false,
            children: []
          }]
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
      } else {
        this.refreshRootVehicleInfoGroups()
      }
    },
    onLoadChildrenGroupData (item, callback) {
      // 加载子区域
      store.dispatch('VehicleInfoGroupServ_GetChildrenGroups', {
        params: { id: item.id },
        urlparams: null
      }).then(() => {
        let tempData = []
        this.tempChildrenGroups = store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult ? store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult : []
        this.tempChildrenGroups.forEach((dtoitem, index) => {
          tempData.push({
            id: dtoitem.id,
            title: dtoitem.name + '[分组数:' + dtoitem.groupCount + ', 车辆数:' + dtoitem.vehicleInfoCount + ']',
            profit: dtoitem.profit,
            expand: false,
            loading: false,
            children: [],
            parent: item
          })
        })
        callback(tempData)
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [
        h('span', [
          h('Icon', {
            props: {
              type: 'ios-paper-outline'
            },
            style: {
              marginRight: '8px'
            }
          }),
          h('span', {
            style: {
              // fontSize:'medium',
              // backgroundColor:'#2db7f5',
              // color:'#ffffff'
            },
            on: {
              click: () => {
                this.selectVehicleInfosByGroupName = data.title
                this.selectVehicleInfosByGroupId = data.id
                this.setPage(1)
              }
            }
          }, data.title)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '5px'
          }
        }, [
          h('Button', {
            props: {
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                this.addVehicleInfoGroupParentId = data.id
                this.addVehicleInfoGroupModal = true
              }
            }
          }, '+'),
          h('Button', {
            props: {
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                this.vehicleInfoGroupDetailId = data.id
                this.vehicleInfoGroupDetailModal = true
              }
            }
          }, '#'),
          h('Button', {
            props: {
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                this.$Modal.confirm({
                  title: '删除分组',
                  content: '<p>是否确认删除此分组</p>',
                  onOk: () => {
                    store.dispatch('VehicleInfoGroupServ_DeleteObj', { params: { id: data.id } }).then(() => {
                      this.$Message.success('删除成功')
                    }).catch(err => {
                      this.$Message.error(err)
                    })
                  },
                  onCancel: () => {
                  }
                })
              }
            }
          }, '-')
        ])
      ])
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null

      if (this.selectVehicleInfosByGroupId) {
        queryParams.push(genQueryParam('vehicleInfoGroupId', 'EQ', this.selectVehicleInfosByGroupId))
      } else {
        queryParams.push(genQueryParam('vehicleInfoGroupId', 'EQNULL', null))
      }

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.stateFilter) {
        queryParams.push(this.stateFilter)
      }

      store.dispatch('VehicleInfoServ_GetMyPage', {
        params: null,
        urlparams: {
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        if (store.getters.get_VehicleInfo_GetMyPageResult) {
          this.totalElements = store.getters.get_VehicleInfo_GetMyPageResult.totalElements
          this.content = store.getters.get_VehicleInfo_GetMyPageResult.content
          this.pageSize = store.getters.get_VehicleInfo_GetMyPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onGroupOPSuccess () {
      this.refreshRootVehicleInfoGroups()
    },
    refreshRootVehicleInfoGroups () {
      store.dispatch('VehicleInfoGroupServ_GetRootVehicleInfoGroups', {
        params: null,
        urlparams: null
      }).then(() => {
        let tempData = []
        let result = store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult ? store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult : []
        result.forEach((dtoitem, index) => {
          tempData.push({
            id: dtoitem.id,
            title: dtoitem.name + '[分组数:' + dtoitem.groupCount + ', 车辆数:' + dtoitem.vehicleInfoCount + ']',
            expand: false,
            loading: false,
            children: [],
            parent: null
          })
        })
        this.defaultGroupData = tempData
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {

  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      this.treeHeight = window.innerHeight - 195
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        this.treeHeight = window.innerHeight - 195
      }
      this.refreshRootVehicleInfoGroups()
    })
  }
}
</script>
<style>
  .demo-split {
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .demo-split-pane {
    padding: 10px;
  }
</style>
